import { List, Misc, Model } from "@singularsystems/neo-core";
import { NeoGrid } from "@singularsystems/neo-react";
import { IGenericApiClient } from "../../../ApiClients/Catalogues/GenericApiClient";
import { CatalogueEntry } from "../CatalogueEntry";
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import { AppService, DomainTypes, Types } from "../../../DomainTypes";
import CommissionType from "../../../Models/Catalogue/Pipeline/CommissionType";
import { Catalogue } from "@singularsystems/neo-react-services";
import AuthoriseButton from "../../../Components/AuthoriseButton";
import CatalogueAuthorisation from "../CatalogueAuthorisation";
import { NotificationDuration } from "../../../../App/Models/NotificationDuration";

export default class CommissionTypeCatalogueEntry extends CatalogueEntry<CommissionType> {

    private pipelinesApiClient = AppService.get(DomainTypes.ApiClients.CataloguePipeline);
    private notifications = AppService.get(Types.Neo.UI.GlobalNotifications);

    constructor() {
        super("Commission Types", CommissionType);
    }

    public get editRole() {
        return CatalogueRoles.CommissionTypes.Edit;
    }

    public getFetchEndpoint(apiClient: IGenericApiClient) {
        return this.pipelinesApiClient.getCommissionTypes;
    }

    public getSaveEndpoint(apiClient: IGenericApiClient) {
        return this.pipelinesApiClient.saveCommissionTypes;
    }

    public async save(): Promise<CommissionType | null> {
        const commissionType = await super.save();
        AppService.get(DomainTypes.Services.DataCache).commissionTypes.expire();
        return commissionType;
    }

    public renderRow(commissionType: CommissionType, meta: Model.TransformMetaType<CommissionType>) {
        return (
            <NeoGrid.RowGroup expandProperty={meta.isExpanded} >
                <NeoGrid.Row>
                    <NeoGrid.Column bind={meta.commissionTypeName} />
                    <Catalogue.ButtonColumn />
                </NeoGrid.Row>
                <NeoGrid.ChildRow>
                    <NeoGrid.Grid items={commissionType.commissionRates} addButton={{ text: "Add Commission Rate", size: "sm" }} >
                        {(commissionRate, childMeta) => (
                            <NeoGrid.RowGroup>
                                <NeoGrid.Row title="Commission Rates">
                                    <NeoGrid.Column bind={childMeta.commissionRateDate} />
                                    <NeoGrid.Column bind={childMeta.commissionRateValue}
                                        numProps={{ format: Misc.NumberFormat.PercentDecimals, formatString: "#,##0.00######%" }} />
                                    <NeoGrid.ButtonColumn>
                                        <AuthoriseButton
                                            className="me-2"
                                            viewModel={CatalogueAuthorisation.authorisationVM}
                                            currentRecord={commissionRate}
                                            authoriseRoleName={CatalogueRoles.Rates.Authorise}
                                            onDelete={() => {
                                                commissionType.commissionRates.removeWithoutTracking(commissionRate);
                                                this.dataCache.commissionTypes.expire();
                                            }} />
                                    </NeoGrid.ButtonColumn>
                                    <Catalogue.ButtonColumn
                                        deleteButton={{
                                            onClick: () => {
                                                if (commissionRate.isNew) {
                                                    commissionType.commissionRates.removeWithoutTracking(commissionRate);
                                                }
                                                else {
                                                    commissionRate.isPendingDelete = !commissionRate.isPendingDelete;
                                                    if (commissionRate.isPendingDelete) {
                                                        this.notifications.addInfo("Mark Deleted", `Please click save to action this request.`, NotificationDuration.Standard);
                                                    }
                                                }
                                            },
                                            icon: commissionRate.isPendingDelete ? "trash-restore" : "trash",
                                            tooltip: commissionRate.isPendingDelete ? "Stop the commission rate from being removed when authorised."
                                                                                    : "Mark the commission rate to be removed when authorised."
                                        }} />
                                </NeoGrid.Row>
                            </NeoGrid.RowGroup>
                        )}
                    </NeoGrid.Grid>
                </NeoGrid.ChildRow>
            </NeoGrid.RowGroup>
        )
    }
}